import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import { SxProps, Theme } from '@mui/system';

interface CenteredContentProps extends BoxProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const CenteredContent: React.FC<CenteredContentProps> = ({ children, sx, ...rest }) => {
  return (
    <Box
      {...rest}
      sx={{
        maxWidth: 1200,
        margin: '0 auto',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default CenteredContent;
